import { LiveEventListItemFragment } from 'web-queries/src/types/generated'
import { findImage, getMediaPath } from './image'

export const liveListToEvents = (liveList: LiveEventListItemFragment[]) => {
  return (
    liveList.map(live => {
      const livePosterImage = findImage(live.posters[0]?.formats)?.url
      const poster = livePosterImage ? getMediaPath(livePosterImage) : '/images/bg_music_live_stage.jpg'

      return {
        id: live.id,
        title: live.title,
        musicians: live.musicians,
        poster,
        start: new Date(live.startDate),
        end: new Date(live.endDate ?? live.startDate),
        allDay: false,
      }
    }) ?? []
  )
}
